
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

interface FAQ {
  question: string;
  answer: string;
}

interface FAQAccordionProps {
  faqs: FAQ[];
  questions?: FAQ[]; // For backward compatibility
}

export const FAQAccordion = ({ faqs, questions }: FAQAccordionProps) => {
  // Use questions prop as a fallback for backward compatibility
  const faqItems = faqs || questions || [];
  
  return (
    <Accordion type="single" collapsible className="w-full">
      {faqItems.map((faq, index) => (
        <AccordionItem key={index} value={`item-${index}`} className="border-b border-dental-light/30">
          <AccordionTrigger className="text-left font-medium text-lg py-4">
            {faq.question}
          </AccordionTrigger>
          <AccordionContent className="text-dental-muted pb-4">
            {faq.answer}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
};
